export type UiStyleName = 'legacy' | 'glass';

export const UI_STYLE_STORAGE_KEY = 'luacentrix.ui_style';

export const UI_STYLE_ORDER: Array<UiStyleName> = ['legacy', 'glass'];

function supportsValue(property: string, value: string): boolean {
  if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') {
    return false;
  }
  try {
    return CSS.supports(property, value);
  } catch {
    return false;
  }
}

export function supportsTranslucency(): boolean {
  return (
    supportsValue('backdrop-filter', 'blur(1px)') ||
    supportsValue('-webkit-backdrop-filter', 'blur(1px)')
  );
}

export function supportsRefraction(): boolean {
  return (
    supportsValue('backdrop-filter', 'url("#lc-glass")') ||
    supportsValue('-webkit-backdrop-filter', 'url("#lc-glass")')
  );
}

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;
}

export interface GlassCapability {
  translucency: boolean;
  refraction: boolean;
  reducedMotion: boolean;
}

export function glassCapability(): GlassCapability {
  return {
    translucency: supportsTranslucency(),
    refraction: supportsRefraction(),
    reducedMotion: prefersReducedMotion(),
  };
}

function storedUiStyle(): UiStyleName | null {
  try {
    const value = window.localStorage.getItem(UI_STYLE_STORAGE_KEY);
    return value === 'legacy' || value === 'glass' ? value : null;
  } catch {
    return null;
  }
}

export function readUiStyle(): UiStyleName {
  return storedUiStyle() ?? 'legacy';
}

export function applyUiStyle(style: UiStyleName): void {
  document.documentElement.dataset.uiStyle = style;
  try {
    window.localStorage.setItem(UI_STYLE_STORAGE_KEY, style);
  } catch {
    return;
  }
}
